import React, { useState } from 'react'
import Select from "react-select"

import Modal from "../reusable/modal"

const Permissions = ({ toggle, visible, onOK }) => {
    const [selected, setSelected] = useState(null)

    let methods = [
        {
            name: 'Cashier',
            permissions: ['view', 'receive', 'edit']
        },
        {
            name: 'Restaurant',
            permissions: ['view', 'receive', 'edit']
        },
        {
            name: 'Bar-1',
            permissions: ['view', 'receive', 'edit']
        },
        {
            name: 'Bar-2',
            permissions: ['view', 'receive', 'edit']
        },
        {
            name: 'Store',
            permissions: ['view', 'receive', 'edit']
        }
    ]

    return (
        <Modal
            w="w-1/5"
            title="Permissions"
            toggle={toggle}
            visible={visible}>
            <div className="flex mb-2 justify-center">
                <Select
                    isClearable
                    value={selected}
                    onChange={setSelected}
                    placeholder="Select station" 
                    styles={{ input: styles => ({ ...styles, minWidth: '15em' }) }}
                    options={methods.map(method => ({ label: method.name, value: method.name, ...method }))} />
            </div>
            {
                selected &&
                <table className="table-auto w-full">
                    {/* Table header */}
                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                        <tr>
                            <th className="p-2">
                                <div className="font-semibold text-center">Selected</div>
                            </th>
                            <th className="p-2">
                                <div className="font-semibold text-left">Permission</div>
                            </th>
                        </tr>
                    </thead>
                    {/* Table body */}
                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                        {
                            selected?.permissions?.map(permission =>
                                <tr>
                                    <td className="p-2 text-center items-center h-5">
                                        <input id="remember" aria-describedby="remember" type="checkbox" className="bg-gray-50 border-gray-300 focus:ring-3 focus:ring-blue-300 h-4 w-4 rounded" required />
                                    </td>
                                    <td className="p-2 text-left items-center">
                                        <div className="">{ permission }</div>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            }
            <div className="flex justify-end">
                <button type="submit" className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            </div>
        </Modal>
    )
}

export default Permissions